// src/pages/LoginPage.js
import React from 'react';
import { Button } from '@mui/material';
import { signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { auth } from '../firebase';
import { useNavigate } from 'react-router-dom';

const provider = new GoogleAuthProvider();

const LoginPage = () => {
  const navigate = useNavigate();

  const handleLogin = () => {
    signInWithPopup(auth, provider)
      .then((result) => {
        // Handle successful login
        navigate('/'); // ホームページにリダイレクト
      })
      .catch((error) => {
        // Handle errors here
        console.error("Error logging in: ", error);
      });
  };

  return (
    <div>
      <h1>Login</h1>
      <Button variant="contained" color="primary" onClick={handleLogin}>
        Login with Google
      </Button>
    </div>
  );
};

export default LoginPage;
